<template>
  <v-container grid-list-md text-center>
    <v-row row wrap>
      <v-col xs12>
        <h2>{{ this.getConfigItem("TICKET_CANCELLED_TEXT") }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12>
        <h2>{{ this.getConfigItem("TICKET_CANCELLED_TEXT_LINE2") }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12 v-if="this.getConfigItem('SHOW_INFO_BUTTON_CANCEL', true)">
        <v-btn
          color="info"
          :style="{ color: this.getConfigItem('INFO_COLOUR_TEXT') }"
          @click="$root.backToHome()"
          >{{ this.getConfigItem("BTN_MAINMENU_TEXT") }}</v-btn
        >
      </v-col>
      <v-col xs12 v-else>
        <v-btn
          color="warning"
          :style="{ color: this.getConfigItem('WARNING_COLOUR_TEXT') }"
          @click="$root.backToHome()"
          >{{ this.getConfigItem("BTN_MAINMENU_TEXT") }}</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      // "isShowLoadingMessage",
      // "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
  },
};
</script>
